export enum RewardSectionType {
    Explore = 'Explore',
    MyVoucher = 'MyVoucher',
    Membership = 'Membership'
}